import routes from 'constants/router'

const checkRoutes = (routes, segment) =>
  routes.find((route) => route.key === segment)

const find = (routes, path) => {
  const segments = path.split('.')

  let found = routes,
    temp = null

  for (let i = 0; i <= segments.length - 1; i++) {
    temp = checkRoutes(found, segments[i])
    found = temp ? temp?.routes ?? [temp] : []
  }

  return found
}

export default (path) => find(routes, path)
